/**
 * Handles add to bag button for PLP's (Supported only by favorites and BI best sellers)
 *
 * @module plpAddToBag
 */

import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';

export const PLUGIN_NAME = 'plpAddToBag';

const addToBag = ($el) => {
    let productCode = $el.data('code');
    const $favSize = $('#' + productCode + '-fav-size-value');
    const swatchName = 'product-color-' + productCode;
    const radioBtn = $('input[name=\'' + swatchName + '\']:checked');
    let saveSizeToDb = $el.data('canSaveSize');

    if (radioBtn && radioBtn.length) {
        productCode = radioBtn.closest('.js-plp-swatch').data('code');
        saveSizeToDb = false;
        if ($favSize.length) {
            if ($el.data('code') === productCode) {
                $favSize.text('Size :' + $favSize.data('size'));
            } else {
                $favSize.text('Save your size');
            }
        }
    }
    const isOneSize = $el.data('isOneSize');
    if (!productCode) {
        return;
    }
    let productSize = '';
    if (isOneSize) {
        productSize = 'all';
    } else {
        const $selectedSize = $('#' + productCode + '-fav-size-value');
        if (!$selectedSize.length) {
            openSizeMenu($el, productCode, saveSizeToDb);
            return;
        } else {
            productSize = $selectedSize.data('size');
            if ($selectedSize.data('isFavSizeOos')) {
                openSizeMenu($el, productCode, saveSizeToDb);
                return;
            }
        }
    }

    if (productSize === undefined || productSize === '') {
        return;
    }

    let data = {
        productCode: productCode,
        size: productSize,
        sectionURL: $el.data('sectionUrl') || window.rcProps.sectionUrl,
        sessionID: window.rcProps.sessionId,
        count: 1,
        csrfHash: window.rcProps.csrfHash,
    };
    addProductWithData(data);
}

function openSizeMenu($el, productCode, saveSizeToDb) {
    const $sizeEl = $el.closest('.js-plp-container').find('.plp__select-size').find('.js-select-size');
    const $size = $sizeEl.clone();
    $size.insertAfter($sizeEl);
    $sizeEl.remove();

    const sizePath = window.rcProps.sizeMarkupUri + '?code=' + productCode;
    $size.attr('data-size-path', sizePath);

    if (saveSizeToDb) {
        const updateSizePath = window.rcProps.updateProductSizeUri + '?code=' + productCode;
        $size.attr('update-size-path', updateSizePath);
    }
    $size.attr('code', productCode);
    const $sizeTrigger = $el.closest('.js-plp-container').find('.plp__select-size').find('.js-select-size-trigger')
    if ($sizeTrigger.length) {
        $sizeTrigger.data('addToBag', 'true');
        $sizeTrigger.data('code', productCode);
        $('.js-select-size').data('saveSize', saveSizeToDb).sizeSelection();
        $sizeTrigger.click();
    }
}

/**
 * Add To Bag Functionality for PLP (Supported on Favorites/BI Best Seller Page atm)
 *
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
export default function plpAddToBag(el, options = {}) {
    const $el = $(el);

    $el.on('click', (e) => {
        e.preventDefault();
        addToBag($el);
    });
}

registerJQueryPlugin(PLUGIN_NAME, plpAddToBag);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/add-to-bag.js